// extracted by mini-css-extract-plugin
module.exports = {"SettingStyle":"_3VZAMY5-RH45EJB-oxdNl6"};